module.exports = __webpack_public_path__ + "static/media/1029288.5d932882.png";